import { render, staticRenderFns } from "./signuppage.vue?vue&type=template&id=5d50cde2&scoped=true"
import script from "./signuppage.vue?vue&type=script&lang=js"
export * from "./signuppage.vue?vue&type=script&lang=js"
import style0 from "./signuppage.vue?vue&type=style&index=0&id=5d50cde2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50cde2",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn,QInput,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn,QInput})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
